import { benefitLongBgMap } from './utils';
import monthImg from '@/assets/images/vip/vip-month-icon.png';
import weeklyImg from '@/assets/images/vip/vip-week-icon.png';
import dayImg from '@/assets/images/vip/vip-day-icon.png';
import levelUpImg from '@/assets/images/vip/vip-upgrade-icon.png';
import domainImg from './images/vip-domain-icon.png';
import rewardNicknameImg from './images/vip-reward-nickname-icon.png';
import loseReturnImg from './images/vip-lose-return-icon1.png';
import loseReturnImg2 from './images/vip-lose-return-icon.png';
import dedicatedSupportImg from './images/vip-dedicated-support-icon.png';
import superVipSupportImg from './images/vip-super-support-icon.png';
import exclusiveChannelImg from './images/vip-exclusive-channel-icon.png';

import withdrawBenefitImg from './images/vip-withdraw-benefit-icon.png';
import priorityWithdrawImg from './images/vip-priority-withdraw-icon.png';
import largeAmountWithdrawImg from './images/vip-large-amount-withdraw-icon.png';
import noLoginMonthlyImg from './images/vip-nologin-month-icon.png';

import type { StaticImageData } from 'next/image';
import vipLevelImg from './images/water.png';

import goldImg from './images/vip-badge-gold.png';
import platinumImg from './images/vip-badge-platinum.png';
import diamondImg from './images/vip-badge-diamond.png';
import silverImg from './images/vip-badge-silver.png';

import goldTitleImg from './images/vip-gold-title.png';
import platinumTitleImg from './images/vip-platinum-title.png';
import diamondTitleImg from './images/vip-diamond-title.png';
import silverTitleImg from './images/vip-silver-title.png';

import bgSilverImg from './images/vip-level-bg-slver.png';
import bgGoldImg from './images/vip-level-bg-gold.png';
import bgPlatinumImg from './images/vip-level-bg-platinum.png';
import bgDiamondImg from './images/vip-level-bg-diamond.png';

import starImg1 from './images/vip-level-star1.png';
import starImg2 from './images/vip-level-star2.png';
import starImg3 from './images/vip-level-star3.png';
import starImg4 from './images/vip-level-star4.png';
import starImg5 from './images/vip-level-star5.png';

import currentLevel1Img from './images/vip-current-level1-bg.png';
import currentLevel2Img from './images/vip-current-level2-bg.png';
import currentLevel3Img from './images/vip-current-level3-bg.png';
import currentLevel4Img from './images/vip-current-level4-bg.png';

export enum BenefitType {
  lose_return = 'lose_return', // 现金返还
  daily_reward = 'daily_reward', // 每日奖励
  monthly_reward = 'monthly_reward', // 每月奖励
  weekly_reward = 'weekly_reward', // 每周奖励  
  upgrade_reward = 'upgrade_reward', // 晋级奖励
  withdraw_benefit = 'withdraw_benefit', // 提现权益
  priority_withdraw = 'priority_withdraw',  // 优先提现
  large_amount_withdraw = 'large_amount_withdraw', // 大额提现
  custom_nickname = 'custom_nickname', // 自定义昵称
  dedicated_support = 'dedicated_support',  // 专属客服
  super_vip_support = 'super_vip_support',  // 超级 VIP 客服
  exclusive_channel = 'exclusive_channel', // 专属频道
  custom_domain = 'custom_domain', // 专属域名
}

export enum BenefitRewardStatus {
  pending = 1,
  claimed = 2,
  expired = 3,
  counting = 4,
}

export const benefitMap: Record<BenefitType, {
  src: StaticImageData;
  src2?: StaticImageData;
  bg: string;
  title: any;
  desc: any;
}> = {
  [BenefitType.lose_return]: {
    src: loseReturnImg,
    src2: loseReturnImg2,
    bg: benefitLongBgMap['3']?.src,
    title: 'benefits.cashback',
    desc: 'descriptions.cashbackRate',
  },
  [BenefitType.monthly_reward]: {
    src: monthImg,
    src2: noLoginMonthlyImg,
    bg: benefitLongBgMap['4']?.src,
    title: 'benefits.monthlyBonus',
    desc: 'descriptions.monthlyBonusCalculation',
  },
  [BenefitType.weekly_reward]: {
    src: weeklyImg,
    bg: benefitLongBgMap['4']?.src,
    title: 'benefits.weeklyBonus',
    desc: 'descriptions.weeklyBonusCalculation',
  },
  [BenefitType.upgrade_reward]: {
    src: levelUpImg,
    bg: benefitLongBgMap['3']?.src,
    title: 'benefits.levelUpBonus',
    desc: 'descriptions.levelUpReward',
  },
  [BenefitType.withdraw_benefit]: {
    src: withdrawBenefitImg,
    bg: benefitLongBgMap['2']?.src,
    title: 'benefits.freeWithdrawals',
    desc: 'descriptions.freeWithdrawalCount',
  },
  [BenefitType.priority_withdraw]: {
    src: priorityWithdrawImg,
    bg: benefitLongBgMap['4']?.src,
    title: 'benefits.priorityWithdrawal',
    desc: 'descriptions.priorityWithdrawal',
  },
  [BenefitType.large_amount_withdraw]: {
    src: largeAmountWithdrawImg,
    bg: benefitLongBgMap['4']?.src,
    title: 'benefits.largeWithdrawal',
    desc: 'descriptions.withdrawalLimit',
  },
  [BenefitType.custom_nickname]: {
    src: rewardNicknameImg,
    bg: benefitLongBgMap['1']?.src,
    title: 'benefits.customNickname',
    desc: 'descriptions.nicknameCustomization',
  },
  [BenefitType.dedicated_support]: {
    src: dedicatedSupportImg,
    bg: benefitLongBgMap['1']?.src,
    title: 'benefits.dedicatedSupport',
    desc: 'descriptions.dedicatedSupport',
  },
  [BenefitType.super_vip_support]: {
    src: superVipSupportImg,
    bg: benefitLongBgMap['4']?.src,
    title: 'benefits.superSupport',
    desc: 'descriptions.vipSupport',
  },
  [BenefitType.exclusive_channel]: {
    src: exclusiveChannelImg,
    bg: benefitLongBgMap['4']?.src,
    title: 'benefits.exclusiveChannel',
    desc: 'descriptions.exclusiveChannel',
  },
  [BenefitType.custom_domain]: {
    src: domainImg,
    bg: benefitLongBgMap['4']?.src,
    title: 'benefits.customDomain',
    desc: 'descriptions.customDomain',
  },
  [BenefitType.daily_reward]: {
    src: dayImg,
    bg: benefitLongBgMap['4']?.src,
    title: 'benefits.dailyBonus',
    desc: 'descriptions.dailyBonusCalculation',
  },
};

export const vipLevelIndexMap: Record<number, any> = {
  1: {
    indexStr: 'I',
    starImg: starImg1,
  },
  2: {
    indexStr: 'II',
    starImg: starImg2,
  },
  3: {
    indexStr: 'III',
    starImg: starImg3,
  },
  4: {
    indexStr: 'IV',
    starImg: starImg4,
  },
  5: {
    indexStr: 'V',
    starImg: starImg5,
  },
};

// vip等级信息
export const levelMap: Record<number, any> = {
  1: {
    img: vipLevelImg,
    name: 'levels.silver',
    showLevel: 1,
    bgLevel: silverImg,
    bgModalLevel: bgSilverImg,
    titleImg: silverTitleImg,
    progressbarBg: 'bg-accent-green',
    menuCardBg: 'linear-gradient(140deg, rgba(2,203,18,0.13) 0%,rgba(2,203,18,0) 100%)',
    currentLevelImg: currentLevel1Img,
    currentLevelColor: '#145526',
  },
  2: {
    img: vipLevelImg,
    name: 'levels.silver',
    showLevel: 2,
    bgLevel: silverImg,
    bgModalLevel: bgSilverImg,
    titleImg: silverTitleImg,
    progressbarBg: 'bg-accent-green',
    menuCardBg: 'linear-gradient(140deg, rgba(2,203,18,0.13) 0%,rgba(2,203,18,0) 100%)',
    currentLevelImg: currentLevel1Img,
    currentLevelColor: '#145526',
  },
  3: {
    img: vipLevelImg,
    name: 'levels.silver',
    showLevel: 3,
    bgLevel: silverImg,
    bgModalLevel: bgSilverImg,
    titleImg: silverTitleImg,
    progressbarBg: 'bg-accent-green',
    menuCardBg: 'linear-gradient(140deg, rgba(2,203,18,0.13) 0%,rgba(2,203,18,0) 100%)',
    currentLevelImg: currentLevel1Img,
    currentLevelColor: '#145526',
  },
  4: {
    img: vipLevelImg,
    name: 'levels.silver',
    showLevel: 4,
    bgLevel: silverImg,
    bgModalLevel: bgSilverImg,
    titleImg: silverTitleImg,
    progressbarBg: 'bg-accent-green',
    menuCardBg: 'linear-gradient(140deg, rgba(2,203,18,0.13) 0%,rgba(2,203,18,0) 100%)',
    currentLevelImg: currentLevel1Img,
    currentLevelColor: '#145526',
  },
  5: {
    img: vipLevelImg,
    name: 'levels.silver',
    showLevel: 5,
    bgLevel: silverImg,
    bgModalLevel: bgSilverImg,
    titleImg: silverTitleImg,
    progressbarBg: 'bg-accent-green',
    menuCardBg: 'linear-gradient(140deg, rgba(2,203,18,0.13) 0%,rgba(2,203,18,0) 100%)',
    currentLevelImg: currentLevel1Img,
    currentLevelColor: '#145526',
  },
  6: {
    img: vipLevelImg,
    name: 'levels.gold',
    showLevel: 1,
    bgLevel: goldImg,
    bgModalLevel: bgGoldImg,
    titleImg: goldTitleImg,
    progressbarBg: 'bg-accent-yellow',
    menuCardBg: 'linear-gradient(140deg, rgba(255,162,0,0.13) 0%,rgba(255,162,0,0) 100%)',
    currentLevelImg: currentLevel2Img,
    currentLevelColor: '#7F641E',
  },
  7: {
    img: vipLevelImg,
    name: 'levels.gold',
    showLevel: 2,
    bgLevel: goldImg,
    bgModalLevel: bgGoldImg,
    titleImg: goldTitleImg,
    progressbarBg: 'bg-accent-yellow',
    menuCardBg: 'linear-gradient(140deg, rgba(255,162,0,0.13) 0%,rgba(255,162,0,0) 100%)',
    currentLevelImg: currentLevel2Img,
    currentLevelColor: '#7F641E',
  },
  8: {
    img: vipLevelImg,
    name: 'levels.gold',
    showLevel: 3,
    bgLevel: goldImg,
    bgModalLevel: bgGoldImg,
    titleImg: goldTitleImg,
    progressbarBg: 'bg-accent-yellow',
    menuCardBg: 'linear-gradient(140deg, rgba(255,162,0,0.13) 0%,rgba(255,162,0,0) 100%)',
    currentLevelImg: currentLevel2Img,
    currentLevelColor: '#7F641E',
  },
  9: {
    img: vipLevelImg,
    name: 'levels.gold',
    showLevel: 4,
    bgLevel: goldImg,
    bgModalLevel: bgGoldImg,
    titleImg: goldTitleImg,
    progressbarBg: 'bg-accent-yellow',
    menuCardBg: 'linear-gradient(140deg, rgba(255,162,0,0.13) 0%,rgba(255,162,0,0) 100%)',
    currentLevelImg: currentLevel2Img,
    currentLevelColor: '#7F641E',
  },
  10: {
    img: vipLevelImg,
    name: 'levels.gold',
    showLevel: 5,
    bgLevel: goldImg,
    bgModalLevel: bgGoldImg,
    titleImg: goldTitleImg,
    progressbarBg: 'bg-accent-yellow',
    menuCardBg: 'linear-gradient(140deg, rgba(255,162,0,0.13) 0%,rgba(255,162,0,0) 100%)',
    currentLevelImg: currentLevel2Img,
    currentLevelColor: '#7F641E',
  },
  11: {
    img: vipLevelImg,
    name: 'levels.platinum',
    showLevel: 1,
    bgLevel: platinumImg,
    bgModalLevel: bgPlatinumImg,
    titleImg: platinumTitleImg,
    progressbarBg: 'bg-accent-blue',
    menuCardBg: 'linear-gradient(140deg, rgba(0,132,255,0.13) 0%,rgba(0,132,255,0) 100%)',
    currentLevelImg: currentLevel3Img,
    currentLevelColor: '#1A458A',
  },
  12: {
    img: vipLevelImg,
    name: 'levels.platinum',
    showLevel: 2,
    bgLevel: platinumImg,
    bgModalLevel: bgPlatinumImg,
    titleImg: platinumTitleImg,
    progressbarBg: 'bg-accent-blue',
    menuCardBg: 'linear-gradient(140deg, rgba(0,132,255,0.13) 0%,rgba(0,132,255,0) 100%)',
    currentLevelImg: currentLevel3Img,
    currentLevelColor: '#1A458A',
  },
  13: {
    img: vipLevelImg,
    name: 'levels.platinum',
    showLevel: 3,
    bgLevel: platinumImg,
    bgModalLevel: bgPlatinumImg,
    titleImg: platinumTitleImg,
    progressbarBg: 'bg-accent-blue',
    menuCardBg: 'linear-gradient(140deg, rgba(0,132,255,0.13) 0%,rgba(0,132,255,0) 100%)',
    currentLevelImg: currentLevel3Img,
    currentLevelColor: '#1A458A',
  },
  14: {
    img: vipLevelImg,
    name: 'levels.platinum',
    showLevel: 4,
    bgLevel: platinumImg,
    bgModalLevel: bgPlatinumImg,
    titleImg: platinumTitleImg,
    progressbarBg: 'bg-accent-blue',
    menuCardBg: 'linear-gradient(140deg, rgba(0,132,255,0.13) 0%,rgba(0,132,255,0) 100%)',
    currentLevelImg: currentLevel3Img,
    currentLevelColor: '#1A458A',
  },
  15: {
    img: vipLevelImg,
    name: 'levels.platinum',
    showLevel: 5,
    bgLevel: platinumImg,
    bgModalLevel: bgPlatinumImg,
    titleImg: platinumTitleImg,
    progressbarBg: 'bg-accent-blue',
    menuCardBg: 'linear-gradient(140deg, rgba(0,132,255,0.13) 0%,rgba(0,132,255,0) 100%)',
    currentLevelImg: currentLevel3Img,
    currentLevelColor: '#1A458A',
  },
  16: {
    img: vipLevelImg,
    name: 'levels.diamond',
    showLevel: 1,
    bgLevel: diamondImg,
    bgModalLevel: bgDiamondImg,
    titleImg: diamondTitleImg,
    progressbarBg: 'bg-accent-red',
    menuCardBg: 'linear-gradient(140deg, rgba(232,55,12,0.13) 0%,rgba(232,55,12,0) 100%)',
    currentLevelImg: currentLevel4Img,
    currentLevelColor: '#843B29',
  },
  17: {
    img: vipLevelImg,
    name: 'levels.diamond',
    showLevel: 2,
    bgLevel: diamondImg,
    bgModalLevel: bgDiamondImg,
    titleImg: diamondTitleImg,
    progressbarBg: 'bg-accent-red',
    menuCardBg: 'linear-gradient(140deg, rgba(232,55,12,0.13) 0%,rgba(232,55,12,0) 100%)',
    currentLevelImg: currentLevel4Img,
    currentLevelColor: '#843B29',
  },
  18: {
    img: vipLevelImg,
    name: 'levels.diamond',
    showLevel: 3,
    bgLevel: diamondImg,
    bgModalLevel: bgDiamondImg,
    titleImg: diamondTitleImg,
    progressbarBg: 'bg-accent-red',
    menuCardBg: 'linear-gradient(140deg, rgba(232,55,12,0.13) 0%,rgba(232,55,12,0) 100%)',
    currentLevelImg: currentLevel4Img,
    currentLevelColor: '#843B29',
  },
  19: {
    img: vipLevelImg,
    name: 'levels.diamond',
    showLevel: 4,
    bgLevel: diamondImg,
    bgModalLevel: bgDiamondImg,
    titleImg: diamondTitleImg,
    progressbarBg: 'bg-accent-red',
    menuCardBg: 'linear-gradient(140deg, rgba(232,55,12,0.13) 0%,rgba(232,55,12,0) 100%)',
    currentLevelImg: currentLevel4Img,
    currentLevelColor: '#843B29',
  },
  20: {
    img: vipLevelImg,
    name: 'levels.diamond',
    showLevel: 5,
    bgLevel: diamondImg,
    bgModalLevel: bgDiamondImg,
    titleImg: diamondTitleImg,
    progressbarBg: 'bg-accent-red',
    menuCardBg: 'linear-gradient(140deg, rgba(232,55,12,0.13) 0%,rgba(232,55,12,0) 100%)',
    currentLevelImg: currentLevel4Img,
    currentLevelColor: '#843B29',
  },
};

export const demoMockSummary = {
  "code": 0,
  "msg": "Success",
  "data": {
    "user_membership": {
      "level": 12,
      "next_membership": {
        "level": 13,
        "min_point": 650000000
      }
    },
    "user_points": 987.42,
    "benfits": [
      {
        "type": "lose_return",
        "is_locked": false,
        "reward_status": 1,
        "extra": {
          "lose_rate": 0.1
        }
      },
      {
        "type": "weekly_reward",
        "is_locked": false,
        "reward_status": 2,
        "extra": {
          "next_distributed_at": 0
        }
      },
      {
        "type": "monthly_reward",
        "is_locked": false,
        "reward_status": 3,
        "extra": {
          "next_distributed_at": 0
        }
      },
      {
        "type": "upgrade_reward",
        "is_locked": false,
        "reward_status": 3,
        "extra": {}
      },
      {
        "type": "withdraw_benefit",
        "is_locked": false,
        "reward_status": 1,
        "extra": {
          "daily_remain_withdraw_amount": 500,
          "daily_remain_withdraw_number": 1
        }
      },
      {
        "type": "custom_nickname",
        "is_locked": false,
        "reward_status": 1,
        "extra": {}
      }
    ],
    "memberships": {
      "list": [
        {
          "level": 1,
          "min_point": 10,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.01
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": true
              },
              {
                "name": "提现权益",
                "is_locked": true
              },
              {
                "name": "自定义昵称权益",
                "is_locked": true
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 2,
          "min_point": 100,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.02
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": true
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 3,
          "min_point": 1000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.03
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": true
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 4,
          "min_point": 10000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.04
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": true
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 5,
          "min_point": 25000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.05
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": true
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 6,
          "min_point": 50000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.06
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": true
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 7,
          "min_point": 100000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.07
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": true
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 8,
          "min_point": 200000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.08
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": true
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 9,
          "min_point": 400000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.09
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": true
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 10,
          "min_point": 650000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.1
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": true
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 11,
          "min_point": 1000000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.11
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": false
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 12,
          "min_point": 2500000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.12
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": false
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 13,
          "min_point": 5000000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.13
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": false
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 14,
          "min_point": 10000000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.14
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": false
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 15,
          "min_point": 25000000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.15
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": false
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 16,
          "min_point": 50000000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.16
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": false
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 17,
          "min_point": 100000000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.17
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": false
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 18,
          "min_point": 200000000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.18
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": false
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 19,
          "min_point": 400000000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.19
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": false
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
        {
          "level": 20,
          "min_point": 650000000,
          "benfits": {
            "upgrade_reward": {
              "amount": 0,
              "currency": ""
            },
            "lose_return": {
              "lose_rate": 0.2
            },
            "list": [
              {
                "name": "现金返还",
                "is_locked": false
              },
              {
                "name": "每月奖励",
                "is_locked": false
              },
              {
                "name": "每周奖励",
                "is_locked": false
              },
              {
                "name": "晋级奖励",
                "is_locked": false
              },
              {
                "name": "提现权益",
                "is_locked": false
              },
              {
                "name": "自定义昵称权益",
                "is_locked": false
              },
              {
                "name": "专属客服",
                "is_locked": true
              },
              {
                "name": "优先提现",
                "is_locked": true
              },
              {
                "name": "超级 VIP 客服",
                "is_locked": true
              },
              {
                "name": "专属频道",
                "is_locked": true
              },
              {
                "name": "大额提现",
                "is_locked": true
              },
              {
                "name": "专属域名",
                "is_locked": true
              },
              {
                "name": "每日奖励",
                "is_locked": true
              }
            ]
          }
        },
      ],
      "position": 18
    }
  }
};

export const CURRENCY_SYMBOL_MAP = {
  USDT: '$',
  INR: '₹',
  BRL: 'R$',
};

export const CASHBACK_LOSE_RETURN_CYCLE = {
  DAILY: 'daily',
  WEEKLY: 'weekly'
}

// 'en-US', 'hi-IN', 'ur-PK', 'pt-BR', 'es-MX'
export const VIP_BANNER = {
  'en': () => import('@/features/vip/images/banner/vip-nologin-banner-en.jpg'),
  'en-US': () => import('@/features/vip/images/banner/vip-nologin-banner-en.jpg'),
  'hi-IN': () => import('@/features/vip/images/banner/vip-nologin-banner-hi.jpg'),
  'hi': () => import('@/features/vip/images/banner/vip-nologin-banner-hi.jpg'),
  'pt-BR': () => import('@/features/vip/images/banner/vip-nologin-banner-pt.jpg'),
  'pt': () => import('@/features/vip/images/banner/vip-nologin-banner-pt.jpg'),
}